"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSafari = exports.isNode = exports.isMobile = exports.isDesktop = exports.isBrowser = void 0;
var isBrowser = typeof window !== 'undefined' && 'navigator' in window && 'userAgent' in window.navigator;
exports.isBrowser = isBrowser;
var isNode = typeof window === 'undefined';
exports.isNode = isNode;
var isMobile = isBrowser && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
exports.isMobile = isMobile;
var isDesktop = isBrowser && !isMobile;
exports.isDesktop = isDesktop;
var isSafari = isBrowser && /^((?!chrome|android).)*safari/i.test(window.navigator.userAgent);
exports.isSafari = isSafari;